

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";

function Footer({ light }) {
  const { size } = typography;

  return (
    <MDBox position="absolute" width="100%" bottom={0} >
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: "column", lg: "row" }}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
     sx={{   backgroundColor:"rgba(0,0,0,0.7)",padding:1,borderRadius:"10px 10px 0px 0px"}}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "#fff" : "text"}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()}, Sura Trade
        
          </MDBox>

          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "#fff" : "text"}
            fontSize={size.sm}
     
          >
            <MDTypography color="white" sx={{fontSize:14,cursor :"pointer",paddingRight:4}}>
           Privacy Policy    
           </MDTypography>
           <MDTypography color="white" sx={{fontSize:14,cursor :"pointer",paddingRight:4}}>
         Terms and Conditions  
           </MDTypography>
           <MDTypography color="white" sx={{fontSize:14,cursor :"pointer"}}>
        About Us  
           </MDTypography>
          </MDBox>
        
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
};

export default Footer;
